export default __webpack_public_path__ + "static/media/image2.0bf37733.svg";